import React, { useState, useEffect } from 'react';

// Define available triggers
const triggerOptions = [
  { id: 'scene:stealth', label: 'Stealth Mode' },
  { id: 'event:alert', label: 'Alert Triggered' },
  { id: 'scene:chase', label: 'Chase Mode' },
  { id: 'scene:hide', label: 'Hide Mode' }
];

const TriggerSystem = ({ onTrigger }) => {
  const [selectedTrigger, setSelectedTrigger] = useState('');

  useEffect(() => {
    if (selectedTrigger) {
      // Dispatch trigger to parent or other modules
      onTrigger(selectedTrigger);
    }
  }, [selectedTrigger]);

  return (
    <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h3>🎯 Trigger System</h3>
      <select
        value={selectedTrigger}
        onChange={(e) => setSelectedTrigger(e.target.value)}
      >
        <option value="">-- Select Trigger --</option>
        {triggerOptions.map((trigger) => (
          <option key={trigger.id} value={trigger.id}>
            {trigger.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TriggerSystem;